import {MonthsEnum, CalendarYears} from '../enums/MonthsEnum'

const isWinterSeason = (selectedMonth: number, selectedYear: number): boolean => {
    /**
     * Determines if a given month and year falls within the winter season.
     *
     * The winter season starts in December of 2024 and ends the end of 2025. This function
     * checks if the provided month and year fall within the winter season based
     * on the specified configuration.
     *
     * @param {number} selectedMonth - The month to check, represented as an integer (1 for January, 2 for February, etc.).
     * @param {number} selectedYear - The year to check.
     * @returns {boolean} `true` if the month and year fall within the winter season, `false` otherwise.
     */
    if(selectedMonth < MonthsEnum.DECEMBER && selectedYear === CalendarYears.NEXT) return true
    return false
}

export default isWinterSeason